<template>
  <div class="download-page">
    <download-banner></download-banner>
    <choose-platform></choose-platform>

    <h2 class="text-center" id="title">{{ $t('downloadVpn') }} {{ currentPlatformInfo.name === 'Ubuntu' ? 'Linux' : currentPlatformInfo.name }} {{ $t('client') }}</h2>
    <use-plex-step></use-plex-step>
    
    <BannerPopup></BannerPopup>
  </div>
</template>

<script>
  import ChoosePlatform from '../../components/download/choosePlatform/ChoosePlatform.vue'
  import DownloadBanner from '../../components/download/downloadBanner/DownloadBanner.vue'
  import UsePlexStep from '../../components/download/usePlexStep/UsePlexStep.vue'
  import DownloadBtn from '../../components/download/downloadBtn/DownloadBtn.vue'
  import locales from './lang'
  import { mapState } from 'vuex'
  import BannerPopup from "../../components/bannerPopup/BannerPopup.vue"

  export default {
    name: 'download-view',
    components: {
      ChoosePlatform,
      DownloadBanner,
      UsePlexStep,
      DownloadBtn,
      BannerPopup
    },
    computed: {
      currentPlatformInfo() {
        return this.$store.state.download[this.currentPlatform]
      },
      ...mapState({
        mediaType: state => state.mediaType,
        language: state => state.currentLang,
        currentPlatform: state => state.download.currentPlatform,
        platform: state => state.download.platform
      })
    },
    locales,
    beforeCreate: function () {
      if (this.$route.query.utm_campaign) {
        window.sessionStorage.setItem('utmCampaign', this.$route.query.utm_campaign)
      }
    },
    watch: {
      '$route'(to, from) {
        if (to.query.platform !== from.query.platform) {
          this.$store.commit('setCurrentPlatform', this.$route.query.platform)
        }

        if (!this.$route.query.platform) {
          this.$store.commit('setCurrentPlatform', this.platform)
        }
      }
    },
    created() {
      this.$store.commit('resetDefaultActiveLink')
      this.$store.commit('setDefaultActiveLink', 'download')
      this.$store.commit('isSpecialHeader', true)
      if (window.screen.width < 768) {
        this.$store.commit('getdownload', true)
      } else {
        this.$store.commit('getdownload', false)
      }
      this.$store.dispatch('getDownloadInfo')

      if (this.$route.query.platform) {
        const platformList = ['windows', 'mac' , 'ios', 'android', 'androidTV', 'ubuntu']
        const platform = platformList.includes(this.$route.query.platform) ? this.$route.query.platform : 'windows'
        if (!platformList.includes(this.$route.query.platform)) {
          this.$router.push(`/download?platform=${platform}`)
        }
        this.$store.commit('setCurrentPlatform', platform)
      } else {
        this.$store.commit('setCurrentPlatform', this.platform)
      }
    },
    mounted() {
      console.log(this.$route.path)
      this.$store.commit('isSpecialHeader', true)
      let that = this
      window.onresize = function () {
        if (window.screen.width < 768 && that.$route.path === '/download') {
          that.$store.commit('getdownload', true)
        } else {
          that.$store.commit('getdownload', false)
        }
      }
    },
    destroyed() {
      this.$store.commit('isSpecialHeader', false)
      this.$store.commit('getdownload', false)
    }
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .pc-show {
    display: block;
  }

  .phone-show {
    display: none;
  }

  #title {
    padding: 1rem 0 0.6rem;
    margin: 0 auto;
    font-size: 40px;
    color: #111111;
    letter-spacing: 2px;
    line-height: 40px;
    font-weight: 600;
    @media screen and (max-width: 1024px) {
      padding-top: 1.2rem;
    }
  }

  @media screen and (max-width: 767px) {
    .phone-show {
      display: block;
    }
    .pc-show {
      display: none;
    }
    .header-box{
      position: relative;
      top: 60px;
    }
    #title {
      padding: .8rem .24rem 0;
      font-size: 24px;
      line-height: 32px;
      color: #111111;
      letter-spacing: 1.05px;
      font-weight: 600;
    }
    .download-btn-component {
      display: none;
      margin: 0 auto .4rem auto;
    }
  }
</style>



// WEBPACK FOOTER //
// IndexMain.vue?8ff15d56